export const SWIMSAFETY_ASSOCIATION_DASHBOARD_COUNT_SUCCESS =
  'SWIMSAFETY_ASSOCIATION_DASHBOARD_COUNT_SUCCESS';

export const SWIMSAFETY_ASSOCIATION_DASHBOARD_COUNT_FAILURE =
  'SWIMSAFETY_ASSOCIATION_DASHBOARD_COUNT_FAILURE';
